import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Office} from "../models/office";
import {Employee} from "../models/employee";
import {Festivita} from "../models/festivita";
import {Appuntamento, AppuntamentoPage} from "../models/appuntamento";
import {FasceOrarie} from "../models/fasce-orarie";
import {ServizioErogato} from "../models/servizio-erogato";

@Injectable({
  providedIn: 'root'
})
export class PrenotazioneAppuntamentoService {

  public callerPage!: string;
  private url = "services/nextappointment/api";
  private portaleAmministrazioneURL = "services/portaleamministrazione/api"
  private urlNotifiche = "services/portalenotifiche/api"

  constructor(private httpClient: HttpClient) {
  }

  ListaServiziAPI(): Observable<ServizioErogato[]> {
    return this.httpClient.get<ServizioErogato[]>(this.url + "/na-servizi-erogati/getServizi");
  }

  searchAllServizi(servizioErogato: ServizioErogato): Observable<ServizioErogato[]>{
    return this.httpClient.post<ServizioErogato[]>(this.url + "/na-servizi-erogati/searchAllServizi", servizioErogato);
  }

  ListaServiziPrenotazioneSale(): Observable<ServizioErogato[]>{
    return this.httpClient.get<ServizioErogato[]>(this.url + "/na-servizi-erogati/getSaleMonumenti")
  }

  ListaServiziErogatiAttiviAPI(): Observable<ServizioErogato[]> {
    return this.httpClient.get<any>(this.url + "/na-servizi-erogati/search?s=%7B%22flAttivo%22%3A%20%22S%22%7D");
  }

  ListaUfficiByIdSede(id: number): Observable<Office[]> {
    return this.httpClient.get<any>(this.url + "/na-servizi-erogati/getUffici?idServizioId.equals=" + id);
  }

  listaAppuntamentiAPI(idDichiarante: any): Observable<AppuntamentoPage[]> {
    return this.httpClient.get<any>(this.url + "/na-appuntamento/appuntamenti/" + idDichiarante)
  }

  listaAppuntamentiPaginazione(size: number, page: number, dataPrenotazione: string, filtri?: any): Observable<HttpResponse<AppuntamentoPage[]>> {
    return this.httpClient.post<AppuntamentoPage[]>(this.url + `/na-appuntamento/appuntamenti?size=${size}&page=${page}&sort=dataPrenotazione,${dataPrenotazione}`, filtri, {observe: "response"})
  }

  getOperatore(idOperatore: any): Observable<Employee> {
    return this.httpClient.get<any>(this.portaleAmministrazioneURL + "/pn-dipendente/" + idOperatore);
  }

  listaIdDipendentiPerIDServizioUfficio(idServizio: string, idUfficio: string): Observable<ServizioErogato> | null {
    return this.httpClient.get<ServizioErogato>(this.url + "/idDipServizioSede/"+idServizio+"/"+idUfficio)
  }

  /**
   * Ottieni una lista di  di disponibilità dei dipendenti
   *
   * **Nota**: Se per la data di riferimento (mese) non c'è alcuna INDISPONIBILILTA', il BE resituisce 204
   *
   * @returns Ritorna un Observable di {@link Festivita}[]
   *
   * @param idServizioErogato
   * @param dataDiRiferimento
   * @param idDipendente Eventuale id di {@link Employee}
   */
  indisponibilitaMensili(idServizioErogato: string, dataDiRiferimento: Date, idDipendente?: number): Observable<Festivita[]> {
    if (idDipendente)
      return this.httpClient.get<any>(this.url + "/festivita/all?idServizioErogato=" + idServizioErogato + "&data=" + dataDiRiferimento.toISOString() + "&idDipendente=" + idDipendente);
    return this.httpClient.get<any>(this.url + "/festivita/all?idServizioErogato=" + idServizioErogato + "&data=" + dataDiRiferimento.toISOString());
  }

  modificaAppuntamento(form: any): Observable<any> {
    return this.httpClient.patch<any>(this.url + "/na-appuntamento/annullaAppuntamento?id=" + form, null)
  }

  trasferisciAppuntamento(form: any): Observable<any> {
    return this.httpClient.post<any>(this.url + "/na-appuntamento/trasferisciAppuntamento", form)
  }

  /**
   * Ottieni una lista di orari di disponibilità dei dipendenti
   *
   * **Nota**: Se una fascia oraria non ha alcuna disponibilià verrà comunque ritornata ma con una lista `idDipendente` vuota
   *
   * @returns Ritorna un Observable di {@link FasceOrarie}[]
   *
   * @param idServErogato L'id del Servizio Erogato
   * @param idDipendente Eventuale id di {@link Employee}
   * @param giorno Il giorno richiesto, deve essere di tipo {@link Date}
   */
  getSlotOrari(idServErogato: string, giorno: Date, idDipendente?: number): Observable<FasceOrarie[]> {
    if (idDipendente) {
      return this.httpClient.get<FasceOrarie[]>(this.url + "/slot-prenotazioni?idSer=" + idServErogato + "&idDip=" + idDipendente + "&giorno=" + giorno.toISOString());
    }
    return this.httpClient.get<FasceOrarie[]>(this.url + "/slot-prenotazioni?idSer=" + idServErogato + "&giorno=" + giorno.toISOString());
  }

  /**
   * Ottieni tutti i dati di un ServizioErogato avendo il suo id
   *
   *
   * @returns Ritorna un Observable di {@link ServizioErogato}
   *
   * @param idServErogato L'id del Servizio Erogato
   */
  getServizioErogatoById(idServErogato: string): Observable<ServizioErogato> {
    return this.httpClient.get<ServizioErogato>(this.url + "/na-servizi-erogati/" + idServErogato);
  }

  insertNuovoAppuntamento(appuntamento: Appuntamento): Observable<any> {
    return this.httpClient.post<any>(this.url + "/na-appuntamento/insert", appuntamento);
  }

  insertPrenotazioneSaleMonumenti(prenotazione: Appuntamento): Observable<any>{
    return this.httpClient.post<any>(this.url + "/na-appuntamento/insertPrenotazioneSaleMonumenti", prenotazione);

  }

  getListaDipendenti(array: number[]): Observable<any> {
    return this.httpClient.post(this.portaleAmministrazioneURL + "/pn-dipendente/listaDipendenti", array)
  }

  getListaUtenti(array: string[]): Observable<any> {
    return this.httpClient.post(this.portaleAmministrazioneURL + "/pn-utente/listaUtenti", array)
  }

  sendNotificationAPI(template: object): Observable<any> {
    return this.httpClient.post<any>(this.urlNotifiche + '/notifica-front-office', template);
  }
}
